import { Checkbox, Field, TextOutput } from 'Components/Core';
import { ListFieldSection, PageSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { NamePrefixModifier, withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { WorksheetAssociatedTestSection } from '../../../Core';

let LinearShrinkageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector = undefined }) => {
  const notTested = useSelector(pipe(createWorksheetSelector!('LinearShrinkage.NotTested'), valueOrDefault(false)));
  return (
    <PageSection heading="Linear Shrinkage">
      <NamePrefixModifier appendNamePrefix="LinearShrinkage">
        <ListFieldSection>
          <Field input={<Checkbox />} name="NotTested" />
        </ListFieldSection>
        <WorksheetAssociatedTestSection
          name="EmbeddedLinearShrinkage"
          visible={!notTested}
          testType="Linear Shrinkage"
          associatedTestModel={{
            measured: true,
          }}
        />
      </NamePrefixModifier>
      <ListFieldSection visible={notTested}>
        <Field input={<TextOutput />} name="Results.LinearShrinkageText" />
      </ListFieldSection>
    </PageSection>
  );
};

LinearShrinkageSection = withInjectedProps(LinearShrinkageSection);

export { LinearShrinkageSection };
export default LinearShrinkageSection;
